export enum ThresholdTypeEnum {
  LTV = 'LTV',
  LTC = 'LTC',
}
